<i18n
  src="@/locales/views/agro_exporter/finances/container_outcomes/list_processes.yml"
  lang="yaml"
></i18n>
<template>
  <div class="mt-8 mb-8">
    <h1 class="page-title">{{ module_name }}</h1>
  </div>

  <div
    v-if="load_data_general"
    class="bg-white shadow overflow-hidden sm:rounded-md"
  >
    <ul role="list" class="divide-y divide-gray-200">
      <li
        v-for="agro_exporter_process in agro_exporter_processes"
        :key="agro_exporter_process.id"
      >
        <div
          class="block hover:bg-gray-50 cursor-pointer"
          @click.prevent="goToShowProcess(agro_exporter_process.id)"
        >
          <div class="px-4 py-4 sm:px-6">
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-900 truncate">
                {{ agro_exporter_process.name }}
              </p>
              <div class="ml-2 flex-shrink-0 flex">
                <a class="link invisible sm:visible">
                  <i class="fa-solid fa-pen"></i>
                  <span class="space-icon"></span>
                  {{ $t("labels.manage_link") }}
                </a>
              </div>
            </div>
            <div class="mt-2 sm:flex sm:justify-between">
              <div class="sm:flex">
                <p class="flex items-center text-sm text-gray-500 mr-6">
                  <i
                    class="fa-solid fa-ship flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span class="space-icon"></span>
                  {{ agro_exporter_process.num_containers }}
                </p>
                <p class="flex items-center text-sm text-gray-500 mr-6">
                  <i
                    class="fa-solid fa-file-invoice-dollar flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span class="space-icon"></span>
                  {{ agro_exporter_process.num_org_invoices }}
                </p>
                <p class="flex items-center text-sm text-gray-500 mr-6">
                  <i
                    class="fa-solid fa-file-check flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span class="space-icon"></span>
                  {{ agro_exporter_process.num_org_invoices_paid }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <loading-message v-else />
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/finances/container_outcomes/list_processes.js";

export default {
  name: "AeFinancesContainerOutcomesListProcesses",
  props: ["agro_exporter_id"],
  data() {
    return {
      load_data_general: false,
      agro_exporter_processes: [],
    };
  },
  methods: {
    fetchAgroExporterProcesses: async function () {
      let response = await Requester.fetchAgroExporterProcesses(
        this.agro_exporter_id
      );
      this.agro_exporter_processes = response.data;
      this.load_data_general = true;
    },
    goToShowProcess: function (agroexporter_process_id) {
      this.$router.push({
        name: this.routeName("show_process"),
        params: {
          agro_exporter_id: this.agro_exporter_id,
          agro_exporter_process_id: agroexporter_process_id,
        },
      });
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id,
        },
      }).then(() => this.fetchAgroExporterProcesses())
    );
  },
};
</script>
